import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { getSuperAdminSessionKey } from 'Src/helpers/session/superadminSession';

const getImageApiUrl = (): string => String((window as any).apiImg || '').replace(/\/+$/g, '');

export function uploadImage(user: AppUser, image: any) {
  const key = user.roleSessionKey;
  const formData = new FormData();

  formData.append('image', image);

  const config = {
    headers: {
      usid: key,
      'Content-Type': 'multipart/form-data'
    }
  };

  return axios.post(`${getImageApiUrl()}/images`, formData, config).then(response => {
    return response.data;
  });
}

export function uploadSuperAdminImage(image: File) {
  const formData = new FormData();

  formData.append('image', image);

  return axios
    .post(`${getImageApiUrl()}/images`, formData, {
      headers: {
        asid: getSuperAdminSessionKey(),
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => response.data);
}

export function getUploadedImageUrl(response: any): string {
  if (!response) return '';

  return (
    response.link ||
    response.picUrl ||
    response.url ||
    (response.key ? `${getImageApiUrl()}/images/${response.key}` : '')
  );
}
